import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { ResponsiveMode } from 'office-ui-fabric-react/lib/utilities/decorators/withResponsiveMode';
import React, { Component } from 'react';
import { EUINumericField } from '../EUI/EUINumericField';

export class TextFieldTemps extends Component {

    static defaultProps = {
        label: "Temps",
        onChange: (event, newValue, suffix) => { },
        suffix: "Heure",
    };

    constructor(props) {
        super(props);
        this._styles = {
            dropdown: {
                root: { width: 100 },
                title: {
                    backgroundColor: "transparent",
                    border: "none"
                }
            },
            textfield: { suffix: { padding: 0 } }
        };
    };

    _onChangeDropdown = (event, option, index) => {
        const { onChange, value } = this.props;
        onChange(event, value, option.key);
    };

    _onChangeTextField = (event, newValue) => {
        const { onChange, suffix } = this.props;
        onChange(event, newValue, suffix);
    };

    _onRenderSuffix = () => {
        const { disabled, readOnly, suffix } = this.props;
        const { } = this.props;

        return <Dropdown
            disabled={disabled || readOnly}
            onChange={this._onChangeDropdown}
            options={[
                { key: "Minute", text: "Min(s)" },
                { key: "Heure", text: "Heure(s)" },
                { key: "Jour", text: "Jour(s)" }
            ]}
            responsiveMode={ResponsiveMode.Large} // Empêche la Dropdown de s'ouvrir dans un panel (sur petits écrans)
            selectedKey={suffix}
            styles={this._styles.dropdown}
        />;
    };

    render = () => <EUINumericField
        {...this.props}
        min={0}
        onChange={this._onChangeTextField}
        onRenderSuffix={this._onRenderSuffix}
        styles={this._styles.textfield}
    />;

};
